export const householdStatuses = [
  { text: 'Current Resident', value: 'Current Resident' },
  { text: 'Applicant', value: 'Applicant' },
  { text: 'Prior Resident', value: 'Prior Resident' },
];
